import { Howl } from "howler";
import soundConfig from "../SoundConfig";

export const sounds = {
    TripleFreeze: new Howl({ src: [soundConfig.TripleFreeze], preload: false }),
    Points90: new Howl({ src: [soundConfig.Points90], preload: false }),
    TriplaTriplat: new Howl({ src: [soundConfig.TriplaTriplat], preload: false }),
    Freeze: new Howl({ src: [soundConfig.Freeze], preload: false }),
    Triplat: new Howl({ src: [soundConfig.Triplat], preload: false }),
    Ohi: new Howl({ src: [soundConfig.Ohi], preload: false }),
    Fumble: new Howl({ src: [soundConfig.Fumble], preload: false }),
    Rikki: new Howl({ src: [soundConfig.Rikki], preload: false }),
    StrongStart: new Howl({ src: [soundConfig.StrongStart], preload: false }),
    Score: new Howl({ src: [soundConfig.Score], preload: false }),

    // Special alternate sounds
    Special1: new Howl({ src: [soundConfig.Special1], preload: false }),
    Special12: new Howl({ src: [soundConfig.Special12], preload: false }),
    Special24: new Howl({ src: [soundConfig.Special24], preload: false }),
    Special2Dice: new Howl({ src: [soundConfig.Special2Dice], preload: false }),

    // Tie game sound
    TieGame: new Howl({ src: [soundConfig.TieGame], preload: false }),

    // Sounds for each score 0-34
    Points0: new Howl({ src: [soundConfig.Points0], preload: false }),
    Points1: new Howl({ src: [soundConfig.Points1], preload: false }),
    Points2: new Howl({ src: [soundConfig.Points2], preload: false }),
    Points3: new Howl({ src: [soundConfig.points3], preload: false }),
    Points4: new Howl({ src: [soundConfig.points4], preload: false }),
    Points5: new Howl({ src: [soundConfig.points5], preload: false }),
    Points6: new Howl({ src: [soundConfig.points6], preload: false }),
    Points7: new Howl({ src: [soundConfig.points7], preload: false }),
    Points8: new Howl({ src: [soundConfig.points8], preload: false }),
    Points9: new Howl({ src: [soundConfig.points9], preload: false }),
    Points10: new Howl({ src: [soundConfig.points10], preload: false }),
    Points11: new Howl({ src: [soundConfig.points11], preload: false }),
    Points12: new Howl({ src: [soundConfig.points12], preload: false }),
    Points13: new Howl({ src: [soundConfig.points13], preload: false }),
    Points14: new Howl({ src: [soundConfig.points14], preload: false }),
    Points15: new Howl({ src: [soundConfig.points15], preload: false }),
    Points16: new Howl({ src: [soundConfig.points16], preload: false }),
    Points17: new Howl({ src: [soundConfig.points17], preload: false }),
    Points18: new Howl({ src: [soundConfig.points18], preload: false }),
    Points19: new Howl({ src: [soundConfig.points19], preload: false }),
    Points20: new Howl({ src: [soundConfig.points20], preload: false }),
    Points21: new Howl({ src: [soundConfig.points21], preload: false }),
    Points22: new Howl({ src: [soundConfig.points22], preload: false }),
    Points23: new Howl({ src: [soundConfig.points23], preload: false }),
    Points24: new Howl({ src: [soundConfig.points24], preload: false }),
    Points26: new Howl({ src: [soundConfig.points26], preload: false }),
    Points28: new Howl({ src: [soundConfig.points28], preload: false }),
    Points30: new Howl({ src: [soundConfig.points30], preload: false }),
    Points32: new Howl({ src: [soundConfig.points32], preload: false }),
    Points34: new Howl({ src: [soundConfig.Points34], preload: false }),

    //Point sounds for Playercard
    HÄVIÖ: new Howl({ src: [soundConfig.HÄVIÖ], preload: false }),
    MAX_POINTS: new Howl({ src: [soundConfig.MAX_POINTS], preload: false }),
    OHI: new Howl({ src: [soundConfig.OHI], preload: false }),
    OSUTTRIPLAT: new Howl({ src: [soundConfig.OSUTTRIPLAT], preload: false }),
    PISTE_1TO3: new Howl({ src: [soundConfig.PISTE_1TO3], preload: false }),
    PISTE_4TO7: new Howl({ src: [soundConfig.PISTE_4TO7], preload: false }),
    PISTE_8TO11: new Howl({ src: [soundConfig.PISTE_8TO11], preload: false }),
    PISTE_12TO15: new Howl({ src: [soundConfig.PISTE_12TO15], preload: false }),
    PISTE_16TO19: new Howl({ src: [soundConfig.PISTE_16TO19], preload: false }),
    PISTE_20TO23: new Howl({ src: [soundConfig.PISTE_20TO23], preload: false }),
    PISTE_24TO27: new Howl({ src: [soundConfig.PISTE_24TO27], preload: false }),
    PISTE_28TO29: new Howl({ src: [soundConfig.PISTE_28TO29], preload: false }),
    PISTE_30TO31: new Howl({ src: [soundConfig.PISTE_30TO31], preload: false }),
    VOITTOTRIPLATTRIPLAT: new Howl({ src: [soundConfig.VOITTOTRIPLATTRIPLAT], preload: false }),
};

export const playSound = (soundKey: keyof typeof sounds, delay: number = 0) => {
    resumeAudioContext(); // Ensure the context is resumed before playing the sound

    if (delay > 0) {
        setTimeout(() => {
            sounds[soundKey].play();
        }, delay);
    } else {
        sounds[soundKey].play();
    }
};

/**
 * Sounds are created with preload:false so the ~25MB of audio is NOT fetched
 * on app boot (howler auto-loads any sound on first play). Call this when the
 * player enters the game flow so everything is cached before it's needed.
 */
let warmedUp = false;
export const warmupSounds = () => {
    if (warmedUp) return;
    warmedUp = true;
    Object.values(sounds).forEach((howl) => {
        if (howl.state() === 'unloaded') howl.load();
    });
};

export const stopSound = (soundKey: keyof typeof sounds) => {
    sounds[soundKey].stop();
};

// Helper function to resume the AudioContext
export const resumeAudioContext = () => {
    if (Howler.ctx && Howler.ctx.state === "suspended") {
        Howler.ctx.resume().then(() => {
            console.log("AudioContext resumed");
        }).catch(err => {
            console.error("Error resuming AudioContext:", err);
        });
    }
};
